import { gearGrade } from '../config/config';

export const calcPrice = (grade, price) => {
  if (grade === gearGrade.rare) {
    return price * 0.01 * 10;
  }
  if (grade === gearGrade.elite) {
    return price * 0.01 * 100;
  }
  return price;
};
